import React, { Fragment }   from "react";
import {
    Datagrid,
} from 'react-admin';
import FieldGuesser from 'UI/Common/ApiPlateform/FieldGuesser';
import {List} from "../Common/List";
import {useResourceOptions} from "../../hooks";
import {EmptyTitle} from "../Common/Title";
import {CurrencyField} from "../Common/Currency";
import {DateField} from "../Common/DateField";
import {DefaultListProps} from "../Common/DefaultListProps";

export const ListPlain = ({...props }) => {
    const { readableFields, operations } = useResourceOptions(props.resource);
    if(!operations || !operations.list) return null;
    return (
        <Fragment>
            <List  sort={{ field: 'disbursementDate', order: 'DESC' }}  title={<EmptyTitle/>} {...DefaultListProps({operations})}  filters={false} bulkActionButtons={false}  {...props}>
                <Datagrid>
                    {readableFields.disbursementDate && <DateField showTime={false} label={'Date'} source={'disbursementDate'}/>}
                    {readableFields.amount && <CurrencyField label={'Amount'} source={'amount'}/>}
                </Datagrid>
            </List>
        </Fragment>
    );
};


export const StatList = ({...props }) => {
    const { readableFields, operations } = useResourceOptions(props.resource);
    if(!operations || !operations.list) return null;
    return (
        <Fragment>
            <List title={<EmptyTitle/>} actions={false}  filters={false} bulkActionButtons={false}  {...props}>
                <Datagrid>
                    {readableFields.channel && <FieldGuesser label={'Store'} source={'channel.name'}/>}
                    {readableFields.amount && <CurrencyField label={'Amount'} source={'amount'}/>}
                </Datagrid>
            </List>
        </Fragment>
    );
};

export const ListFinal = ListPlain;
